































































































import { Component, Prop, Vue } from 'vue-property-decorator'
import {ICreateUserPopup, SelectOption} from "@/global";
import * as enums from '@/global-enum'
import usersAApi from '@/api/users-a'
import UserInFavoritesToggle from "@/components/UserInFavoritesToggle.vue";

@Component({
    components: {
        UserInFavoritesToggle
    }
})
export default class CreateUserPopup extends Vue implements ICreateUserPopup {
    organizations: SelectOption[] = [];

    isPopupVisible = false;
    isLoading = false;
    isButtonsDisabled = false;

    organizationId: number | null = null;

    email = "";
    inviteKey = "";
    linkAbsolutePath = "";

    get isOrganizationReadonly() {
        return this.organizations.length <= 1
    }

    showError(errorMessage?: string) {
        this.$bvToast.toast(errorMessage || "Спробуйте пізніше", {
            title: "Помилка",
            variant: "danger"
        })
    }

    isValidationScopeValid(scope: string) {
        return this.$appUtils.vvIsValidationScopeValid(this, scope);
    }

    validateState(ref: string, scope?: string) {
        return this.$appUtils.vvValidateState(this, ref, scope);
    }

    async openCreateUserPopup(organizations: SelectOption[]) {
        this.isPopupVisible = true;

        this.isLoading = true;

        this.organizations = organizations;

        // select first organization
        if (this.$helpers.isNotEmptyArray(this.organizations)) {
            this.organizationId = this.organizations![0].id;
        } else {
            throw new Error("organizations should not be null or empty")
        }

        this.isLoading = false;
    }

    onCreateUserPopupClosed() {
        // reset values
        this.isButtonsDisabled = false;

        this.email = "";
        this.inviteKey = "";
        this.linkAbsolutePath = ""
    }

    async sendUserInvite() {
        let isValid = await this.$validator.validateAll('createUserPopup-general');

        if (isValid) {
            isValid = await this.$validator.validateAll('createUserPopup-sendEmail');
        }

        if (isValid) {
            this.isButtonsDisabled = true;

            usersAApi.sendUserInvite(this.email, this.organizationId!, data => {
                if (data.success) {
                    this.email = "";

                    this.$bvToast.toast("Запрошення успішно відправлено на пошту", {
                        title: "Успіх",
                        variant: "success"
                    });
                } else {
                    this.$bvToast.toast("Запрошення не вдалося відправити", {
                        title: "Помилка",
                        variant: "danger"
                    });
                }

                this.isButtonsDisabled = false;
            }, errorMessage => {
                this.isButtonsDisabled = false;

                this.showError(errorMessage)
            });
        }
    }

    async generateUserInviteKey() {
        let isValid = await this.$validator.validateAll('createUserPopup-general');

        if (isValid) {
            this.isButtonsDisabled = true;

            usersAApi.generateUserInviteKey(this.organizationId!, data => {
                this.inviteKey = data.key;
                this.linkAbsolutePath = window.location.origin +
                    this.$router.resolve({ name: 'create-user', params: { key: this.inviteKey } }).href;

                this.isButtonsDisabled = false;
            }, errorMessage => {
                this.isButtonsDisabled = false;

                this.showError(errorMessage)
            });
        }
    }

    resetInviteKeyGeneration() {
        this.inviteKey = "";
        this.linkAbsolutePath = "";
    }
}
